// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__1CfLq","withMobileMargins":"DateRangeInput_withMobileMargins__2fl6n","arrowIcon":"DateRangeInput_arrowIcon__3P3P6"};